import { Flex } from 'antd'
import * as ROUTES from 'src/constants/routes'
import { Menu } from './menu'

const MENUS = [
  {
    label: 'Home',
    path: ROUTES.HOME,
  },
  {
    label: 'About',
    path: ROUTES.ABOUT_US,
  },
  {
    label: 'Explore',
    path: ROUTES.EXPLORE,
  },
  {
    label: 'Project',
    path: ROUTES.PROJECT,
  },
  {
    label: 'News',
    path: ROUTES.NEWS,
  },
  {
    label: 'Contact',
    path: ROUTES.CONTACT,
  },
]

interface MenusProps {
  isMobile?: boolean
  onMenuClick?: () => void
}

export const Menus = ({ isMobile = false, onMenuClick }: MenusProps) => (
  <Flex
    vertical={isMobile}
    gap={isMobile ? 'middle' : 'small'}
    flex={1}
    align="center"
    justify="center"
  >
    {MENUS.map((menu, index) => (
      <Menu key={index} {...menu} isMobile={isMobile} onMenuClick={onMenuClick} />
    ))}
  </Flex>
)
